import { useParams } from 'react-router-dom';
import { useGoToPath } from 'catering/hooks/navigation';
import { buildMenuPath } from 'catering/helpers/paths';

export function useGoToMenuScreen() {
  const { locationSlug } = useParams();
  const { go } = useGoToPath();
  const path = buildMenuPath(locationSlug);
  return ({ isRedirect = false } = {}) => go({ path, isRedirect });
}
